// Réunion Creole translations
const cr = {
  // Common
  common: {
    loading: "Lé an trin sharzé...",
    error: "Nafèr",
    save: "Anrézistré",
    cancel: "Anilé",
    delete: "Efasé",
    edit: "Modifyé",
    share: "Partazé",
    search: "Rosèrshé",
    seeMore: "Vwar plis",
    seeLess: "Vwar mwin",
    back: "Rètourné",
    next: "Apré",
    previous: "Avan",
    yes: "Wi",
    no: "Non",
    ok: "OK",
    close: "Fèrmé",
    send: "Anvoyé",
    submit: "Anvoyé",
    refresh: "Aktualizé",
    retry: "Rééséyé",
    offline: "San konnèksyon",
    online: "An lign",
  },

  // Navigation
  nav: {
    home: "Lakaz",
    feed: "Fil",
    map: "Kart",
    chat: "Kozé",
    profile: "Profil",
    messages: "Mésaz",
    notifications: "Notifikasyon",
    settings: "Paramèt",
    search: "Rosèrsh",
    calendar: "Kalandriyé",
    create: "Kréé",
  },

  // Landing Page
  landing: {
    tagline: "Lo rézo sosyal péi",
    headline: "Tout sak i pass",
    headlineHighlight: "dann out kartié",
    description: "Alèrt, évènman, bon plan... Rèst konèkté èk out kominn. Partaz é découv sak i pass otour a ou.",
    joinButton: "Réjwinn Bourbon",
    discoverButton: "Dékouvèr",
    whyBourbon: "Pourkwa Bourbon ?",
    features: {
      alerts: {
        title: "Alèrt an tan réèl",
        description: "Koupir dolo, bouchon, aksidan... Swa informé toutsuit."
      },
      events: {
        title: "Évènman lokal",
        description: "Konsèr, marshé, fèt kartié... Rat pli aryin."
      },
      deals: {
        title: "Bon plan",
        description: "Promo, louvèrtir, zofr spésyal bann komèrs dann out kartié."
      },
      community: {
        title: "Kominité",
        description: "Koz èk out vwazin, antrèd azot, kré lo lyin."
      }
    },
    stats: {
      communes: "24 kominn",
      communesDesc: "Tout La Rényon",
      realtime: "Tan réèl",
      realtimeDesc: "Alèrt instantané",
      free: "100% gratis",
      freeDesc: "San pib intrusif"
    },
    cta: "Paré pou réjwinn out kominité ?",
    ctaButton: "Kré mon kont gratis"
  },

  // Auth
  auth: {
    login: "Konnèksyon",
    register: "Inskri aou",
    logout: "Dékonnèkté",
    email: "Email",
    password: "Mo d'pass",
    confirmPassword: "Konfirm mo d'pass",
    name: "Non",
    commune: "Kominn",
    selectCommune: "Shwazi out kominn",
    forgotPassword: "Mo d'pass oubliyé ?",
    noAccount: "Pa ankor d'kont ?",
    hasAccount: "Déja un kont ?",
    orContinueWith: "Ou kontinié èk",
    googleLogin: "Kontinié èk Google",
    loginSuccess: "Konnèksyon réisi !",
    registerSuccess: "Inskri réisi !",
    loginError: "Email ou mo d'pass lé pa bon",
    registerError: "Nafèr pandan linskri",
    welcome: "Byinvni si Bourbon",
    welcomeBack: "Bon rétour !",
  },

  // Feed
  feed: {
    title: "Fil daktualité",
    empty: "Nana pwin piblikasyon pou linstant",
    emptyFiltered: "Nana pwin piblikasyon ki korèspon",
    newPost: "Nouvo piblikasyon",
    following: "Abonman",
    allPosts: "Tout bann post",
    trending: "Tandans",
    filters: {
      all: "Tout",
      alerts: "Alèrt",
      events: "Évènman",
      deals: "Bon Plan",
      info: "Info"
    },
    sortBy: {
      recent: "Pli résan",
      popular: "Pli populèr",
      trending: "Tandans"
    }
  },

  // Posts
  post: {
    create: "Kré in post",
    title: "Tit",
    titlePlaceholder: "In tit ki tap dann zyé...",
    content: "Kontni",
    contentPlaceholder: "Partaz sak i pass...",
    category: "Katégori",
    selectCategory: "Shwazi in katégori",
    commune: "Kominn",
    quartier: "Kartié",
    selectQuartier: "Shwazi in kartié (opsyonèl)",
    addImage: "Azout in zimaz",
    addAudio: "Azout in son",
    addPoll: "Azout in sondaz",
    pollQuestion: "Késtyon sondaz",
    pollOption: "Opsyon",
    addOption: "Azout in opsyon",
    pollEndDate: "Dat lafin sondaz",
    eventDate: "Dat lévènman",
    publish: "Publyé",
    publishing: "An trin publyé...",
    published: "Publyé !",
    deleteConfirm: "Efas sa post la ?",
    deleted: "Post efasé",
    like: "Ém sa",
    liked: "Émé",
    comment: "Komanté",
    comments: "Komantèr",
    noComments: "Nana pwin komantèr",
    addComment: "Azout in komantèr...",
    share: "Partazé",
    shares: "partaz",
    report: "Sinyalé",
    reported: "Sinyalé",
    vote: "Voté",
    voted: "Voté",
    votes: "vot",
    pollEnded: "Sondaz fini",
    pollEndsIn: "I fini dan",
  },

  // Categories
  categories: {
    alerte: "Alèrt",
    evenement: "Évènman",
    bon_plan: "Bon Plan",
    info: "Info"
  },

  // Profile
  profile: {
    myProfile: "Mon profil",
    editProfile: "Modifié profil",
    bio: "Bio",
    bioPlaceholder: "Koz anou d'ou...",
    followers: "Aboné",
    following: "Abonman",
    posts: "Piblikasyon",
    follow: "Suiv",
    unfollow: "Arèt suiv",
    message: "Mésaz",
    badges: "Baz",
    noBadges: "Pa ankor d'baz",
    joined: "Manb dépi",
    commerce: "Profil Komèrs",
    verifiedCommerce: "Komèrs vérifié",
  },

  // Messages
  messages: {
    title: "Mésaz",
    noConversations: "Nana pwin konvèrsasyon",
    startConversation: "Komans in konvèrsasyon",
    typeMessage: "Ékri out mésaz...",
    sent: "Anvoyé",
    delivered: "Livré",
    read: "Li",
    newMessage: "Nouvo mésaz",
    unread: "pa li",
    unreadPlural: "pa li",
  },

  // Notifications
  notifications: {
    title: "Notifikasyon",
    empty: "Nana pwin notifikasyon",
    markAllRead: "Mark tout kom li",
    newLike: "la émé out piblikasyon",
    newComment: "la komanté out piblikasyon",
    newFollow: "i suiv aou astèr",
    newMessage: "la anvoy aou in mésaz",
    types: {
      like: "Ém sa",
      comment: "Komantèr",
      follow: "Abonman",
      message: "Mésaz"
    }
  },

  // Chat
  chat: {
    title: "Kozé kartié",
    selectRoom: "Shwazi in salon",
    noMessages: "Nana pwin mésaz dann sa salon la",
    typeMessage: "Ékri out mésaz...",
    members: "manb",
    join: "Réjwinn",
    joined: "Réjwin",
    rooms: "Salon",
  },

  // Map
  map: {
    title: "Kart",
    nearYou: "Pré d'ou",
    showAll: "Afish tout",
    filters: "Filt",
  },

  // Calendar
  calendar: {
    title: "Kalandriyé",
    noEvents: "Nana pwin évènman prévi",
    today: "Zordi",
    upcoming: "I vyin",
  },

  // Search
  search: {
    title: "Rosèrsh",
    placeholder: "Rosèrsh bann post, itilizatèr...",
    noResults: "Nana pwin rézilta",
    trending: "Tandans domoman",
    users: "Itilizatèr",
    posts: "Piblikasyon",
  },

  // Settings
  settings: {
    title: "Paramèt",
    account: "Kont",
    notifications: "Notifikasyon",
    privacy: "Konfidansyalité",
    language: "Lang",
    theme: "Tèm",
    themes: {
      light: "Klèr",
      dark: "Fonbr",
      system: "Sistèm"
    },
    about: "A prop",
    help: "Ède",
    logout: "Dékonnèkté",
    deleteAccount: "Efas mon kont",
    version: "Vèrsyon",
    pushNotifications: "Notifikasyon push",
    emailNotifications: "Notifikasyon email",
  },

  // Commerce
  commerce: {
    title: "Profil Komèrs",
    name: "Non lo komèrs",
    description: "Dèskri",
    category: "Katégori",
    address: "Ladrès",
    phone: "Téléfon",
    website: "Sit wèb",
    hours: "Zorèr",
    categories: {
      restaurant: "Rèstoran",
      boutique: "Boutik",
      service: "Sèrvis",
      artisan: "Artizan",
      other: "Ot"
    },
    verify: "Domand vérifikasyon",
    verificationPending: "Vérifikasyon an kour",
    verified: "Vérifié",
  },

  // Report
  report: {
    title: "Sinyalé",
    reason: "Rézon lo sinyalman",
    reasons: {
      spam: "Spam",
      inappropriate: "Kontni pa konvnab",
      harassment: "Arsèlman",
      misinformation: "Fos info",
      other: "Ot"
    },
    details: "Détay siplémentèr",
    detailsPlaceholder: "Èksplik pourkwa ou sinyalé sa kontni la...",
    submit: "Anvoy lo sinyalman",
    submitted: "Sinyalman anvoyé",
    thanks: "Mèrsi pou out vijilans !",
  },

  // Time
  time: {
    now: "Astèr",
    minutesAgo: "nana {n} min",
    hoursAgo: "nana {n}h",
    daysAgo: "nana {n}j",
    weeksAgo: "nana {n} sémèn",
    monthsAgo: "nana {n} mwa",
    yearsAgo: "nana {n} an",
  },

  // Errors
  errors: {
    generic: "In nafèr la rivé",
    network: "Nafèr konnèksyon",
    notFound: "Paz pa trouvé",
    unauthorized: "Aksé pa otorizé",
    forbidden: "Aksé intèrdi",
    serverError: "Nafèr servèr",
    tryAgain: "Éséy ankor",
  },

  // PWA
  pwa: {
    offline: "Ou lé san konnèksyon",
    offlineMessage: "Vérifié out konnèksyon intèrnèt",
    updateAvailable: "Miz a jour disponib",
    updateMessage: "In nouvo vèrsyon lé disponib. Ou vé rafrèshi ?",
    install: "Instal laplikasyon",
  }
};

export default cr;
